module.exports = __webpack_public_path__ + "img/BAU Seniors_19.7a0a1477.jpg";